"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendOTP = void 0;
var axios_1 = __importDefault(require("axios"));
var store_1 = require("../../../store");
function sendOTP(data) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var state, user, url, body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, store_1.redux_store.getState()];
                case 1:
                    state = _b.sent();
                    return [4 /*yield*/, state.userState];
                case 2:
                    user = (_b.sent()).user;
                    url = (_a = process.env.SMS_API) !== null && _a !== void 0 ? _a : "";
                    body = {
                        sendOptions: {
                            campaignName: "OTP",
                            senderId: "SkyApp01",
                            costCentre: "SKYLIFE",
                            testMode: false,
                        },
                        messages: [
                            {
                                content: "Hey ".concat(user.name, ". Use the following OTP to verify your number: ").concat(data.otp),
                                destination: data.phone,
                                customerId: "12345",
                            },
                        ],
                    };
                    return [4 /*yield*/, (0, axios_1.default)({
                            method: "POST",
                            url: "".concat(url, "/v1/BulkMessages"),
                            headers: {
                                authorization: "Basic ".concat(process.env.SMS_API_KEY),
                            },
                            data: body,
                        })
                            .then(function (response) {
                            return response.data;
                        })
                            .catch(function (error) { })];
                case 3: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
exports.sendOTP = sendOTP;
